export const shippingKeys = {
  all: (storeId: string) => ['stores', storeId, 'shipping'] as const,
  zones: (storeId: string) => [...shippingKeys.all(storeId), 'zones'] as const,
};
